import React from 'react'
function GamesAreatwo() {

  
  return (
	 <section className="just-gamers-area just-gamers-bg pt-115 pb-120">
            <div className="container">
              <div className="row">
                <div className="col-xl-5 col-lg-6 col-md-10">
                  <div className="section-title title-style-three white-title mb-70">
                    <h2>JUST FOR <span>GAMERS</span></h2>
                    <p>Compete with 100 player on a remote island for winner
                      known issue where certain strategic</p>
                  </div>
                  <div className="just-gamers-list">
                    <ul>
                      <li>
                        <div className="just-gamers-list-icon">
                          <img src="assets/img/icon/gamer_list_icon01.png" alt="" />
                        </div>
                        <div className="just-gamers-list-content fix">
                          <h5>VR Development</h5>
                          <p>See how well critics rating new video game release with 100 players</p>
                        </div>
                      </li>
                      <li>
                        <div className="just-gamers-list-icon">
                          <img src="assets/img/icon/gamer_list_icon02.png" alt="" />
                        </div>
                        <div className="just-gamers-list-content fix">
                          <h5>Design &amp; Strategy</h5>
                          <p>Village and the subline of her own road, the Line Lane. Pityful a rethoric question</p>
                        </div>
                      </li>
                      <li>
                        <div className="just-gamers-list-icon">
                          <img src="assets/img/icon/gamer_list_icon03.png" alt="" />
                        </div>
                        <div className="just-gamers-list-content fix">
                          <h5>Jungle Pharaoh</h5>
                          <p>Village and the subline of her own road, the Line Lane. Pityful a rethoric question</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-7 col-lg-6 d-none d-lg-block">
                  <div className="just-gamers-img">
                    <img src="assets/img/images/just_gamers_img.png" alt="" className="just-gamers-character" />
                    <div className="just-gamers-circle-shape">
                      <img src="assets/img/images/gamers_circle_line.png" alt="" />
                      <img src="assets/img/images/gamers_circle_shape.png" alt="" className="rotateme" />
                    </div>
                    <img src="assets/img/images/just_gamers_chart.png" alt="" className="gamers-chart-shape" />
                  </div>
                </div>
              </div>
            </div>
          </section>
  )
}

export default GamesAreatwo